import { render, staticRenderFns } from "./TwoColumnsPage.vue?vue&type=template&id=257511a7&scoped=true"
import script from "./TwoColumnsPage.vue?vue&type=script&lang=js"
export * from "./TwoColumnsPage.vue?vue&type=script&lang=js"
import style0 from "./TwoColumnsPage.vue?vue&type=style&index=0&id=257511a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257511a7",
  null
  
)

export default component.exports